// extracted by mini-css-extract-plugin
export default {"container":"assistant_container__ZZd3x","name":"assistant_name__8+XZG"};